function getMonthList(locales) {
  const formatter = new Intl.DateTimeFormat(locales, {
    month: "long"
  });
  return Array.from(Array(12).keys()).map(getMonthName);
  function getMonthName(index) {
    return formatter.format(new Date(2023, index));
  }
}
export {
  getMonthList
};
//# sourceMappingURL=helpers.js.map
